module.exports = __webpack_public_path__ + "img/6.155f8697.jpg";